import { Injectable } from '@angular/core';
import { SessionProxy } from '../../proxy/session';
import { InfoService } from '../info';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { el } from 'date-fns/locale';

@Injectable()
export class SessionService {
  /**
   *
   */
  constructor(private proxy: SessionProxy, private infoService: InfoService) {}

  getInvestors() {
    return this.proxy.getInvestors();
  }

  setSelectedInvestor(investorId: number) {
    localStorage['ad-ip-module'] = investorId;
  }

  getSelectedInvestorId() {
    if (localStorage['ad-ip-module']) {
      return +localStorage['ad-ip-module'];
    }
    return null;
  }

  isShadow() {
    let loginUserId = this.infoService.info.user.id,
      currentUserId = this.getSelectedInvestorId();

    if (currentUserId && currentUserId !== loginUserId) {
      return true;
    } else {
      return false;
    }
  }

  getDefaultPage() {
    return this.proxy.getDefaultPage();
  }

  dataSettingVisiblity() {
    if (environment.feature.newApi === false) {
      return this.proxy.dataSettingVisiblity();
    } else {
      return of(true);
    }
  }

  shadowSession() {
    return this.infoService.shadowSession();
  }
}
